// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19565a60","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Group/Group.vue
// module id = 18
// module chunks = 0